export const followMouse = function (el) {
    const iW = el.getBoundingClientRect().width;
    const iH = el.getBoundingClientRect().height;
    const word = el.querySelector(".block__area--word");
    const screenRatio = iW / iH;
    const wordImageRatio = parseFloat(word.getAttribute("data-ratio"), 10);
    const wordSide = word.classList.contains("block__area--right")
        ? ".block__area--right"
        : ".block__area--left";
    const wordSideContra = word.classList.contains("block__area--right")
        ? ".block__area--left"
        : ".block__area--right";

    const wordRow = word.getAttribute("data-row") == "1" ? 1 : 0;
    const wordRowContra = word.getAttribute("data-row") == "1" ? 0 : 1;
    let percentageOfWindowX;
    let percentageOfWindowY;
    const min = parseInt(word.getAttribute("data-min"), 10);
    const max = parseInt(word.getAttribute("data-max"), 10);
    const text = el.querySelector(".block__area--text div");

    const blockWidth = word.getAttribute("data-original-block-width");
    moveBlocks(blockWidth);

    if (text) {
        text.style.width = getComputedStyle(text.parentNode).width;
        setTimeout(function () {
            text.style.opacity = 1;
        }, 500);
    }

    el.addEventListener("mouseenter", function () {
        if (text) {
            text.style.opacity = 0;
        }
        el.classList.add("blocks__block--faster");
        el.classList.remove("blocks__block--slower");
        const blockWidth = word.getAttribute("data-hover-block-width");
        moveBlocks(blockWidth);
    });

    el.addEventListener("mouseleave", function () {
        if (text) {
            setTimeout(function () {
                text.style.opacity = 1;
            }, 500);
        }
        el.classList.remove("blocks__block--faster");
        el.classList.add("blocks__block--slower");
        const blockWidth = word.getAttribute("data-original-block-width");
        moveBlocks(blockWidth);
    });

    /*

    let cL;
    let cT;


    window.addEventListener("mousemove", function (e) {
        cL = e.clientX;
        cT = e.clientY;
        moveBlocks(cL, cT);
    });


    */
    function moveBlocks(blockWidth) {
        // percentageOfWindowX = x / iW;
        // percentageOfWindowY = y / iH;
        // const blockWidth = percentageOfWindowX.map(min, max, 0, 100);
        const blockItemsRight = el.querySelectorAll(wordSide);

        for (var i = 0; i < blockItemsRight.length; i += 1) {
            blockItemsRight[i].style.width = `${
                blockWidth // (blockWidth / screenRatio) * wordImageRatio
            }%`;
        }
        const blockItemsLeft = el.querySelectorAll(wordSideContra);
        for (var i = 0; i < blockItemsLeft.length; i += 1) {
            blockItemsLeft[i].style.width = `${
                100 - blockWidth // 100 - (blockWidth / screenRatio) * wordImageRatio
            }%`;
        }

        const rowItems = el.querySelectorAll(".blocks__row");
        let wordRow = 0;
        for (var j = 0; j < rowItems.length; j++) {
            if (rowItems[j].querySelector(".block__area--word") != null) {
                wordRow = j;
            }
        }
        rowItems[wordRow].style.height = `${
            (blockWidth * screenRatio) / wordImageRatio
            // blockWidth
        }%`;
        rowItems[wordRow == 1 ? 0 : 1].style.height = `${
            100 - (blockWidth * screenRatio) / wordImageRatio
            // 100 - blockWidth
        }%`;
    }

    // moveBlocks(iW / 10, iH / 10);
};
